import { LoggingService } from '@instinet-analytics/core-lib';
import IndigoServiceClient from 'communication/IndigoServiceClient';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';

export interface UserPreferencesApiOptions {
    loggingService: LoggingService;
    indigoServiceClient: IndigoServiceClient;
}

interface GetKeyResponse {
    key: string;
    value?: string;
}

export class UserPreferencesApi {
    private indigoServiceClient: IndigoServiceClient;
    private logger: Logger;

    public constructor(options: UserPreferencesApiOptions) {
        this.indigoServiceClient = options.indigoServiceClient;
        this.logger = buildLogger('UserPreferencesApi', options.loggingService);
    }

    public async fetchUserPreference<T>(
        key: string,
        options: ApiRequestOptions
    ): Promise<T | undefined> {
        const url = 'user/data/key/' + key;

        const ret = await IndigoApiError.runHandlingErrorsAsync(
            `Fetch User Preference`,
            async () => {
                return await this.indigoServiceClient.get<
                    GetKeyResponse | null | undefined
                >(url, options);
            }
        );
        if (ret?.value) {
            return JSON.parse(ret.value) as T;
        }
        return undefined;
    }

    public async saveUserPreference<T>(
        key: string,
        body: T,
        options: ApiRequestOptions
    ) {
        const url = 'user/data/addKey/' + key;

        return await IndigoApiError.runHandlingErrorsAsync(
            `Save User Preference`,
            async () => {
                return await this.indigoServiceClient.post(url, body, options);
            }
        );
    }
}
